import React from "react";
import { StyledPagination, StyledTablePagination } from "../StyledComponents/styled";
import { Box, Stack } from "@mui/material";

const tablePaginationToolbarSx = {
  ".MuiTablePagination-toolbar": {
    padding: 0,
    minHeight: "auto",
  },
  ".MuiTablePagination-spacer": {
    display: "none",
  },
};

const showingLabel = ({ from, to, count }) => "Showing " + from + " - " + to + " of " + count;

const gridCellSx = {
  display: "flex",
  alignItems: "center",
  minWidth: 0,
  minHeight: 40,
};

const NumberedPagination = ({
  totalCount,
  defaultSelectedPage,
  changeCall,
  rowSizeChangeCall,
  rowSize,
  totalRecordCount,
  rightSlot = null,
}) => {
  const handleChangeRowsPerPage = (event) => {
    rowSizeChangeCall(parseInt(event.target.value, 10));
  };

  const pageIndex = parseInt(defaultSelectedPage - 1, 10);

  const showingBlock = (
    <StyledTablePagination
      rowsPerPageOptions={[]}
      component="div"
      count={totalRecordCount}
      page={pageIndex}
      onPageChange={() => {}}
      rowsPerPage={rowSize}
      onRowsPerPageChange={handleChangeRowsPerPage}
      ActionsComponent={() => null}
      labelDisplayedRows={showingLabel}
      sx={tablePaginationToolbarSx}
    />
  );

  const centerControls = (
    <Stack direction="row" spacing={2} alignItems="baseline" justifyContent="center">
      <StyledPagination
        count={totalCount}
        onChange={changeCall}
        variant="text"
        page={defaultSelectedPage}
        siblingCount={2}
        sx={{ marginTop: "0px !important" }}
      />
      <StyledTablePagination
        rowsPerPageOptions={[10, 20, 50, 100]}
        component="div"
        count={totalRecordCount}
        page={pageIndex}
        onPageChange={() => {}}
        rowsPerPage={rowSize}
        onRowsPerPageChange={handleChangeRowsPerPage}
        ActionsComponent={() => null}
        labelDisplayedRows={() => null}
        sx={tablePaginationToolbarSx}
      />
    </Stack>
  );

  const hasRightSlot = rightSlot !== null && rightSlot !== false;

  const rightColumnContent =
    hasRightSlot === true ? (
      <Box
        sx={{
          ...gridCellSx,
          justifyContent: "flex-end",
          width: "100%",
          // Footer actions (e.g. Download Excel) must not add layout margins.
          "& .MuiButton-root": {
            marginTop: "0 !important",
            marginBottom: "0 !important",
          },
        }}
      >
        {rightSlot}
      </Box>
    ) : (
      <Box
        aria-hidden
        sx={{
          ...gridCellSx,
          justifyContent: "flex-end",
          width: "100%",
          visibility: "hidden",
          pointerEvents: "none",
        }}
      >
        {showingBlock}
      </Box>
    );

  return (
    <Box
      width="100%"
      display="grid"
      gridTemplateColumns="1fr auto 1fr"
      alignItems="center"
      columnGap={2}
    >
      <Box sx={{ ...gridCellSx, justifyContent: "flex-start", justifySelf: "stretch" }}>
        {showingBlock}
      </Box>

      <Box sx={{ ...gridCellSx, justifyContent: "center", justifySelf: "stretch" }}>
        {centerControls}
      </Box>

      <Box sx={{ justifySelf: "stretch" }}>
        {rightColumnContent}
      </Box>
    </Box>
  );
};

export default NumberedPagination;
